import LogoProject from '/logo_full.svg'
import LogoMdigitalProject from '/md_logo_text.svg'

import { ImageLazy } from 'shared/ui/image-lazy'

import styles from './styles.module.scss'

const AppLoaderGlobal = () => {
  return (
    <div className={styles.container}>
      <ImageLazy
        src={LogoProject}
        alt="loader"
      />

      <div className={styles.wrapper}>
        <ImageLazy
          alt="loader"
          src={LogoMdigitalProject}
          className={styles.iconMd}
        />
      </div>
    </div>
  )
}

export default AppLoaderGlobal
